import script from "./Gartenkultur-Tasks.vue?vue&type=script&setup=true&lang=js"
export * from "./Gartenkultur-Tasks.vue?vue&type=script&setup=true&lang=js"

import "./Gartenkultur-Tasks.vue?vue&type=style&index=0&id=48464b40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48464b40"]])

export default __exports__